var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSocial = function SvgSocial(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 17,
    fill: "none",
    viewBox: "0 0 26 17"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 2,
    d: "M18.497 5.673c1.278 0 2.313-1.046 2.313-2.336C20.81 2.047 19.775 1 18.497 1c-1.277 0-2.313 1.046-2.313 2.337 0 1.29 1.036 2.336 2.313 2.336z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "M24 12a5.66 5.66 0 00-1.918-3.325A5.556 5.556 0 0018.5 7.364a5.556 5.556 0 00-3.582 1.311A5.66 5.66 0 0013 12h11z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 2,
    d: "M8.996 7.948c1.626 0 2.944-1.332 2.944-2.974C11.94 3.33 10.622 2 8.996 2 7.371 2 6.053 3.331 6.053 4.974c0 1.642 1.318 2.974 2.943 2.974z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "M16 16a7.203 7.203 0 00-2.442-4.232A7.072 7.072 0 009 10.1c-1.666 0-3.28.59-4.558 1.67A7.204 7.204 0 002 16h14z"
  })));
};
export default SvgSocial;